import { render, staticRenderFns } from "./BtnDetalharRequisicao.vue?vue&type=template&id=1496494b"
import script from "./BtnDetalharRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnDetalharRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports